import React from 'react';
import ReactModal from 'react-modal';

import ModalHeader from './ModalHeader';

export type Props<P extends InstanceProps, T> = Omit<P, keyof InstanceProps> & {
  modal: React.ComponentType<P>;
  children(props: RenderProps<T>): React.ReactNode;
  onClose?: () => any;
};

export interface InstanceProps {
  close: () => any;
  className?: string;
}

export interface RenderProps<T> {
  open(): any;
}

interface State<T> {
  isOpen: boolean;
}

export default class Modal<P extends InstanceProps, T> extends React.PureComponent<Props<P, T>, State<T>> {
  static Header = ModalHeader;

  state: State<T> = { isOpen: false };

  open = () => this.setState({ isOpen: true });
  close = () => this.setState({ isOpen: false }, this.props.onClose);

  render() {
    const { modal: Component, children, onClose, ...rest } = this.props;
    const { isOpen } = this.state;

    return (
      <React.Fragment>
        <ReactModal
          isOpen={isOpen}
          className="relative"
          htmlOpenClassName="overflow-hidden"
          bodyOpenClassName="overflow-hidden"
          overlayClassName="fixed inset-0 inline-flex justify-center bg-black/50 transition-colors duration-300 overflow-auto z-40"
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          onRequestClose={this.close}
        >
          <div className="my-16">
            <Component {...(rest as unknown as P)} close={this.close} />
          </div>
        </ReactModal>

        {children({ open: this.open })}
      </React.Fragment>
    );
  }
}
